import React from 'react';
import { Chart } from 'react-google-charts';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

const SalesByPaymentType = (props) => {
  const { classes } = props;
  return (<div className={'w-100 flex justify-content-between'}>
    { /*<Card className={classes.root}>
    <CardHeader subheader="Sales By Payment Type" classes={{ subheader: classes.header }} />
<CardContent>*/ }
  <div className={classes.container}>
  <Chart
      height={'400px'}
      width={'100%'}
      //height={'300px'}
      //width={'500px'}
      chartType="PieChart"
      loader={<div>Loading Chart</div>}
      data={[
        ['Task', 'Hours per Day'],
        ['Chinese', 37],
        ['Italian', 17],
        ['Mexican', 15],
        ['Punjabi', 15],
        ['Milk Shakes', 16],
      ]}
      options={{
        title: 'Sales By Top Cuisines',
        colors: ['#f58634', '#ffa600', '#6baf30', '#548100', '#969600'],
        legend: { position: 'right' },
      }}
      rootProps={{ 'data-testid': '1' }}
    />

    {/* <Chart
      height={'400px'}
      width={'100%'}
      chartType="PieChart"
      loader={<div>Loading Chart</div>}
      style={{ marginTop: '10px'}}
      data={[
        ['Task', 'Hours per Day'],
        ['Chinese', 37],
        ['Italian', 17],
        ['Mexican', 15],
        ['Punjabi', 15],
        ['Milk Shakes', 16],
      ]}
      options={{
        title: "Sales By Payment Type",
        titleTextStyle: { fontSize: '20px' },
        colors: ['#f58634', '#ffa600', '#6baf30', '#548100', '#969600'],
        legend: {position: 'bottom'},
      }}
      rootProps={{ 'data-testid': '2' }}
    /> */}
</div>
<div className={classes.container}>
   <Chart
      height={'400px'}
      width={'100%'}
      chartType="PieChart"
      loader={<div>Loading Chart</div>}
      style={{ marginTop: '10px'}}
      data={[
        ['Task', 'Hours per Day'],
        ['Self Pickup', 100],
        ['Home Delivery', 67]
      ]}
      options={{
        title: "Sales By Delivery Method",
        titleTextStyle: { fontSize: '20px' },
        colors: ['#f58634', '#6baf30' ],
        legend: {position: 'bottom'},
        pieHole: 0.5,
      }}
      rootProps={{ 'data-testid': '2' }}
      />
        
      <div id="center">
             <font style={{ fontWeight: 'bold', font: '18px arial, sans-serif' }}>230,900</font>
             <br/>
             <font style={{ font: '14px arial, sans-serif' }}>Sales</font>
          </div>
</div>
<div className={classes.container}>
   <Chart
      height={'400px'}
      width={'100%'}
      chartType="PieChart"
      loader={<div>Loading Chart</div>}
      style={{ marginTop: '10px'}}
      data={[
        ['Task', 'Hours per Day'],
        ['Chefs', 59],
        ['Restaurants', 41]
      ]}
      options={{
        title: "Sales By Chefs vs Restaurants",
        titleTextStyle: { fontSize: '20px' },
        colors: ['#f58634', '#6baf30' ],
        legend: {position: 'bottom'},
      }}
      rootProps={{ 'data-testid': '2' }}
    />
</div>
    
    { /* </CardContent>
    </Card> */ }
  </div>)
};

export default SalesByPaymentType;
